export default "__VITE_ASSET__CdbLFH3T__"